import type { ReactNode } from 'react'
import { DiscordIcon } from '#bv/components/DiscordIcon'

const stroke = {
  width: 24,
  height: 24,
  fill: 'none' as const,
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
}

const ICONS: Record<string, ReactNode> = {
  discord: <DiscordIcon size={22} />,
  streaming: (
    <svg {...stroke} viewBox="0 0 24 24">
      <polygon points="23 7 16 12 23 17 23 7" />
      <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
    </svg>
  ),
  gaming: (
    <svg {...stroke} viewBox="0 0 24 24">
      <line x1="6" y1="12" x2="10" y2="12" />
      <line x1="8" y1="10" x2="8" y2="14" />
      <circle cx="15" cy="12" r="1" />
      <circle cx="18" cy="10" r="1" />
      <path d="M4 8h16a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2z" />
    </svg>
  ),
  social: (
    <svg {...stroke} viewBox="0 0 24 24">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  tiktok: (
    <svg {...stroke} viewBox="0 0 24 24">
      <path d="M14 4v8.4a4.2 4.2 0 1 1-4.2-4.2" />
      <path d="M14 4c1.2 1 2.6 1.4 4.5 1.4" />
    </svg>
  ),
  instagram: (
    <svg {...stroke} viewBox="0 0 24 24">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" />
    </svg>
  ),
  youtube: (
    <svg {...stroke} viewBox="0 0 24 24">
      <path d="M3 7.8c0-1 .8-1.8 1.8-1.8h14.4c1 0 1.8.8 1.8 1.8v8.4c0 1-.8 1.8-1.8 1.8H4.8c-1 0-1.8-.8-1.8-1.8V7.8z" />
      <polygon points="10 9.2 16 12 10 14.8" fill="currentColor" stroke="none" />
    </svg>
  ),
  software: (
    <svg {...stroke} viewBox="0 0 24 24">
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
      <line x1="8" y1="21" x2="16" y2="21" />
      <line x1="12" y1="17" x2="12" y2="21" />
    </svg>
  ),
}

export function CategoryIcon({ id }: { id: string }) {
  return ICONS[id] ?? null
}
